export const append = (buttonElement) => {
  buttonElement
    .append("rect")
    .classed("dashboard-button-mousetrap", true)
    .style("fill", "transparent")
  computeAttributes(buttonElement)
}

export const computeAttributes = (buttonElement) => {
  const datum = buttonElement.datum()
  buttonElement
    .selectAll(".dashboard-button-mousetrap")
    .attr("width", datum.width)
    .attr("height", datum.height)
}
